import React from 'react'
import { ethers } from 'ethers'
import Swal from 'sweetalert2'
import PwnTokenABI from '../abis/PwnToken.json'

export interface ConnectWalletResult {
  address: string
  status: string | React.ReactElement
}

export const toastMixin = Swal.mixin({
  toast: true,
  icon: 'success',
  title: 'General Title',
  position: 'top-right',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export const toastErrorMixin = Swal.mixin({
  toast: true,
  icon: 'error',
  title: 'Error',
  position: 'top-right',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export const connectWallet = async (): Promise<ConnectWalletResult | undefined> => {
  const POLYGON_TESTNET_CHAIN_ID = import.meta.env.VITE_POLYGON_TESTNET_CHAIN_ID

  if (window.ethereum) {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum)

      let chainId = await provider.send('eth_chainId', [])
      if (chainId !== POLYGON_TESTNET_CHAIN_ID) {
        await provider.send('wallet_switchEthereumChain', [{ chainId: POLYGON_TESTNET_CHAIN_ID }])
        chainId = await provider.send('eth_chainId', [])
      }

      if (chainId === POLYGON_TESTNET_CHAIN_ID) {
        const addressArray: string[] = await provider.send('eth_requestAccounts', [])

        if (addressArray.length > 0) {
          return { address: addressArray[0], status: '👆🏽 Your wallet is connected to the site.' }
        } else {
          toastMixin.fire({ title: '😥 Connect your wallet account to the site.', icon: 'error' })
          return { address: '', status: '😥 Connect your wallet account to the site.' }
        }
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err)
      return {
        address: '',
        status: '😥 ' + message
      }
    }
  } else {
    toastMixin.fire({
      title:
        '🦊 You must install Metamask, a virtual Ethereum wallet, in your browser.(https://metamask.io/download.html)',
      icon: 'error'
    })
    return {
      address: '',
      status: (
        <span>
          <p> 🦊 You must install Metamask, a virtual Ethereum wallet, in your browser.(https:</p>
        </span>
      )
    }
  }
}

export interface ProviderBundle {
  provider: ethers.providers.Web3Provider
  signer: ethers.providers.JsonRpcSigner
}

const getProvider = (): ProviderBundle => {
  const provider = new ethers.providers.Web3Provider(
    window.ethereum as ethers.providers.ExternalProvider
  )
  const signer = provider.getSigner()

  return { provider, signer }
}

const getPWNTokenContract = (): ethers.Contract => {
  const { signer } = getProvider()

  const contract = new ethers.Contract(
    import.meta.env.VITE_TOKEN_ADDRESS as string,
    PwnTokenABI,
    signer
  )

  return contract
}

export const getPWNBalance = async (walletAddress: string | null | undefined): Promise<string> => {
  if (!walletAddress) {
    return 'X'
  }

  const contract = getPWNTokenContract()
  const balance = await contract.balanceOf(walletAddress)

  return ethers.utils.formatEther(balance)
}
